import React, { Suspense } from 'react';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';

import { lazyWithRetry } from '../../utils/lazyWithRetry';

const EncounterViewV2 = lazyWithRetry(() => import('./components/v2/EncounterViewV2'));

/**
 * Permanent entry point for viewing and editing encounters.
 */
export const EncounterPage: React.FC = () => {
  return (
    <Suspense fallback={<CenteredSpinner />}>
      <EncounterViewV2 />
    </Suspense>
  );
};

export default EncounterPage;
